import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Table } from 'primeng/table';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-construction-element-type',
  templateUrl: './construction-element-type.component.html',

})
export class ConstructionElementTypeComponent implements OnInit {

  showModal: boolean = false;
  modalTitle: string = "";
  elementTypeList: MasterDTO[] = [];
  modal: MasterDTO = new MasterDTO();
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private masterDataRepository: MasterDataRepository) { }


  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getElementType().subscribe((x) => {
      this.elementTypeList = x.value;
    })
  }

  addModal() {
    this.modal = new MasterDTO();
    this.showModal = !this.showModal;
    this.modalTitle = this.translate.instant('commonbtn.add') + ' ' + this.translate.instant('Master.constructionEleType')
  }

  hideDialog() {
    this.showModal = false;
  }

  save(data: MasterDTO) {
    if (data.id > 0) {
      this.service.updateConstructionElementType(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      })
    }
    else {
      this.service.saveConstructionElementType(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  delete(data: MasterDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      acceptLabel:"Ok",
      accept: () => {
        if (data) {
          this.service
            .deleteConstructionElementType(data.id)
            .subscribe((res) => {
              if (res) {
                this.commonService.successMessage(
                  this.translate.instant('Alerts.DeleteSuccessfully')
                );
                this.getAll();
              }
            });
        }
      }
    });
  }

  onToggleStatus(item: MasterDTO) {
  const updatedItem = { ...item }; 
  this.service.updateConstructionElementType(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: MasterDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.constructionEleType')
    this.modal = data;
    this.showModal = !this.showModal;
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('construction-element-type').subscribe(blob => {
      this.downloadFile(blob, `construction-element-type-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }
}
